import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/search/store';
import { I_FlightInfos } from '@Redux/search/interfaces';
import { formatGA } from './utils';
import { getRtowText } from '@utils/utils';
import sendGa from '@utils/ga';

const useSearchPageGA = (flightData: I_FlightInfos[], pageIndex: number, device: 'm' | 'pc') => {
    const { FilterData, UrlParams } = useSelector((state: RootState) => state.search);
    const isMobile = device === 'm';

    const triggerGa_PC = (page: number) => {
        const startIndex = page * 10 - 10;
        const itemsToSend = flightData.slice(startIndex, startIndex + 10);

        const gaDataItems = formatGA(itemsToSend, getRtowText(UrlParams.Rtow));
        sendGa('view_item_list', { items: gaDataItems });
    };

    const triggerGa_M = (page: number) => {
        const dataCount = page * 10;
        const itemsToSend = flightData.slice(0, dataCount);
        const gaDataItems = formatGA(itemsToSend, getRtowText(UrlParams.Rtow));
        sendGa('view_item_list', { items: gaDataItems });
    };

    // 頁面剛進來的 GA 觸發
    useEffect(() => {
        if (!flightData) return;
        if (FilterData) return;

        isMobile ? triggerGa_M(pageIndex) : triggerGa_PC(pageIndex);
    }, [flightData]);

    useEffect(() => {
        if (!flightData) return;
        isMobile ? triggerGa_M(pageIndex) : triggerGa_PC(pageIndex);
    }, [pageIndex]);
};

export default useSearchPageGA;
